module.exports = __webpack_public_path__ + "static/img/fclab-iso9001.67fabb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/fclab-iso9001.jpg
// module id = BAV9
// module chunks = 0